namespace Matrix.Rebalancer {
    export interface AccountOverrideForm {
        AccountCode: FormatServiceLookupEditor;
        Name: Serenity.StringEditor;
        AccountTypeCode: FormatLookupEditor;
        AccountRoleCode: FormatLookupEditor;
        ManagerCode: FormatLookupEditor;
        BaseCurrency: FormatLookupEditor;
        Tradeable: Serenity.BooleanEditor;
        ExternallyManaged: Serenity.BooleanEditor;
        CashOffsetSecurityId: Serenity.IntegerEditor;
        MaxCash: Serenity.DecimalEditor;
        MinCash: Serenity.DecimalEditor;
        Deleted: Serenity.BooleanEditor;
        Class1: Serenity.StringEditor;
        Class2: Serenity.StringEditor;
        Class3: Serenity.StringEditor;
        Class4: Serenity.StringEditor;
        Class5: Serenity.StringEditor;
        Class6: Serenity.StringEditor;
        Class7: Serenity.StringEditor;
        Class8: Serenity.StringEditor;
        Class9: Serenity.StringEditor;
        Class10: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class AccountOverrideForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.AccountOverride';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountOverrideForm.init)  {
                AccountOverrideForm.init = true;

                var s = Serenity;
                var w0 = FormatServiceLookupEditor;
                var w1 = s.StringEditor;
                var w2 = FormatLookupEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.DecimalEditor;
                var w6 = StaticTextBlock;
                var w7 = ReadOnlyDateTime;

                Q.initFormType(AccountOverrideForm, [
                    'AccountCode', w0,
                    'Name', w1,
                    'AccountTypeCode', w2,
                    'AccountRoleCode', w2,
                    'ManagerCode', w2,
                    'BaseCurrency', w2,
                    'Tradeable', w3,
                    'ExternallyManaged', w3,
                    'CashOffsetSecurityId', w4,
                    'MaxCash', w5,
                    'MinCash', w5,
                    'Deleted', w3,
                    'Class1', w1,
                    'Class2', w1,
                    'Class3', w1,
                    'Class4', w1,
                    'Class5', w1,
                    'Class6', w1,
                    'Class7', w1,
                    'Class8', w1,
                    'Class9', w1,
                    'Class10', w1,
                    'CreatedBy', w6,
                    'CreatedWhen', w7,
                    'UpdatedBy', w6,
                    'UpdatedWhen', w7,
                    'Version', w6
                ]);
            }
        }
    }
}
